var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.018 12c0-.762.13-1.493.36-2.178L1.34 6.802A11.528 11.528 0 00.11 12c0 1.868.442 3.63 1.228 5.194l4.036-3.025A6.81 6.81 0 015.018 12",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.11 5.067c1.69 0 3.217.586 4.417 1.546L20.018 3.2C17.891 1.387 15.164.267 12.11.267c-4.742 0-8.818 2.655-10.77 6.535l4.04 3.02c.93-2.766 3.582-4.755 6.73-4.755",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.11 18.933c-3.149 0-5.801-1.989-6.732-4.755l-4.038 3.02c1.951 3.88 6.027 6.535 10.77 6.535 2.926 0 5.72-1.017 7.818-2.924l-3.834-2.902c-1.081.667-2.443 1.026-3.985 1.026",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.564 12c0-.693-.11-1.44-.273-2.133H12.109V14.4h6.436c-.321 1.546-1.197 2.734-2.45 3.507l3.833 2.902c2.203-2.002 3.636-4.984 3.636-8.809",
    fill: "#4285F4"
  }))));
}

export default SvgGoogle;